import { getAvailableFiles, getLastUploadedFiles, getLS, getProjectId, LS_KEYS } from './ls'
import { Filename } from './types'

export const hackShadowRoot = (element: HTMLElement, style: string) => {
    const s = ce('style')
    s.innerHTML = style
    if (element.shadowRoot)
        element.shadowRoot.appendChild(s)
}

export const secureCall = async (callback, context?: any, window?: any) => {
    try {
        await callback(context, window)
    } catch (error) {
        console.error(error)
    }
}

export const getSelectedItems = (e: HTMLSelectElement) => {
    const sel = e.selectedOptions
    const items: Array<string> = []
    for (let i = 0; i < sel.length; ++i)
        items.push(sel[i].value!)
    return items
}

export const removeAvailableFileElement = (filename: Filename) => {
    const e = elements.availableFiles
    if (!e) return
    for (let i = 0; i < e.options.length; ++i)
        if (e.options[i].value == filename)
            e.options[i].remove()
}

export const splitFilename = (filename: Filename) => {
    const spl = filename.split(': ')
    if (spl.length > 1) {
        const project = spl[0]
        const parsed = spl.slice(1).join(': ')
        return {
            project,
            filename: parsed,
        }
    } else {
        return {
            project: 'No project',
            filename,
        }
    }
}

export const createAvailableFileElement = (orig: Filename, checked: boolean = false) => {
    if (!elements.availableFiles) return
    console.log(orig, checked)
    const elem = document.createElement('fluent-option') as HTMLOptionElement
    elem.value = orig
    elem.selected = checked
    const {project, filename} = splitFilename(orig)
    const div = ce('div', {style: 'margin-bottom: 5px; margin-top: 5px;'})
    div.appendChild(ce('small', project))
    div.appendChild(ce('br'))
    div.appendChild(ce('label', filename))
    elem.appendChild(div)
    elem.setAttribute('style', 'height: 3em')
    //elem.innerText = orig
    elements.availableFiles.appendChild(elem)
}

export const createAccordionItem = (title: string, div: HTMLDivElement, options?: {
    labelClass?: string
    extraLabelDivs?: Array<HTMLDivElement>
}) => {
    const accordionItem = ce('fluent-accordion-item' as any, { class: 'accordionItem' })
    const label = ce('div', title, {slot: 'heading', class: options?.labelClass ?? 'tableClass'})
    accordionItem.appendChild(label)
    accordionItem.appendChild(div)
    for (const extra of options?.extraLabelDivs ?? [])
        label.appendChild(extra)
    return accordionItem
}

export const ce = <T extends keyof HTMLElementTagNameMap>( // {{{
    type: T, 
    text: string | Record<string, string> = '', 
    attributes?: Record<string, string>,
) => {
    const element = document.createElement(type)
    let attrs = attributes ?? {}
    if (typeof text == 'string') {
        if (text)
            element.innerText = text
    } else {
        attrs = text
    }
    for (const [key, value] of Object.entries(attrs))
        element.setAttribute(key, value)
    return element
}

export const createCheckbox = (checked: boolean | undefined, onclick: (this: GlobalEventHandlers, ev: MouseEvent) => any, attributes: Record<string, string> = {}) => {
    const ch = ce('fluent-checkbox' as keyof HTMLElementTagNameMap, Object.assign(attributes)) as HTMLInputElement
    ch.checked = !!checked
    ch.onchange = onclick as any
    return ch
}
export const createLabel = (text: string, forId: string, attributes: Record<string, string> = {}) => 
    ce('label', text, Object.assign(attributes, {'for': forId}))

export const createButton = (text: string, attributes: Record<string, string> = {}) => 
    ce('fluent-button' as keyof HTMLElementTagNameMap, text, attributes)

export const appendCell = (row: HTMLTableRowElement, e: Node, attributes: Record<string, string> = {}) => {
    const cell = row.insertCell()
    cell.appendChild(e)
    for (const [key, value] of Object.entries(attributes))
        cell.setAttribute(key, value)
    return cell
}
// }}}

const raw = () => ({
    //modal
    errorMessages:   document.getElementById('error-messages')    as HTMLDivElement,

    //modal
    saveSelected:    document.getElementById('save-selected')    as HTMLButtonElement,
    selectAllHor:    document.getElementById('select-all-hor')   as HTMLButtonElement,
    selectAllVer:    document.getElementById('select-all-ver')   as HTMLButtonElement,
    deselectAllHor:  document.getElementById('deselect-all-hor') as HTMLButtonElement,
    deselectAllVer:  document.getElementById('deselect-all-ver') as HTMLButtonElement,
    rtfTable:        document.getElementById('rtf-table')        as HTMLTableElement,
    tables:          document.getElementById('tables')           as HTMLDivElement,
    modalBody:       document.getElementById('modal-body')       as HTMLBodyElement,
    loaderFiles:     document.getElementById('loader-files')     as HTMLDivElement,
    loader:          document.getElementById('loader')           as HTMLDivElement,

    //panel
    body:            document.getElementById('app-body')         as HTMLBodyElement,
    run:             document.getElementById('run')              as HTMLButtonElement,
    get:             document.getElementById('get')              as HTMLButtonElement,
    openModal:       document.getElementById('open-modal')       as HTMLButtonElement,
    parseTables:     document.getElementById('parse-tables')     as HTMLButtonElement,
    settings:        document.getElementById('save-settings')    as HTMLButtonElement,
    errorButton:     document.getElementById('error-button')     as HTMLButtonElement,
    authKey:         document.getElementById('auth-key')         as HTMLInputElement,
    projectId:       document.getElementById('project-id')       as HTMLInputElement,
    useCache:        document.getElementById('use-cache')        as HTMLInputElement,
    docType:         document.getElementById('doc-type-select')  as HTMLSelectElement,
    uploadRTF:       document.getElementById('upload')           as HTMLInputElement,
    uploadRTFButton: document.getElementById('upload-button')    as HTMLButtonElement,
    availableFiles:  document.getElementById('available-files')  as HTMLSelectElement,
    deleteFiles:     document.getElementById('delete-files')     as HTMLSelectElement,
    resetSavedFiles: document.getElementById('reset-saved-files') as HTMLSelectElement,
    useAI:           document.getElementById('use-ai')           as HTMLInputElement,
    checkToken:      document.getElementById('check-token')      as HTMLButtonElement,
    tflImportOk:     document.getElementById('tfl-import-ok')    as HTMLDivElement,
    tflImportAd:     document.getElementById('tfl-import-ad')    as HTMLDivElement,
    tflImportPe:     document.getElementById('tfl-import-pe')    as HTMLDivElement,
})

export let elements: ReturnType<typeof raw> = null as any

export const initElements = () => {
    if (!elements) elements = raw()
}

export const setupElements = () => {
    elements.body.style.display = 'block'
    const last = new Set(getLastUploadedFiles())
    const availableFiles = getAvailableFiles()
    for (const filename of availableFiles) {
        createAvailableFileElement(filename, last.has(filename))
    }
    if (elements.authKey)
        elements.authKey.value           = getLS(LS_KEYS.authKeyKey).value ?? ''
    if (elements.projectId)
        elements.projectId.value         = getProjectId()
    if (elements.useCache)
        elements.useCache.checked        = getLS(LS_KEYS.useCacheKey).value ?? false
    if (elements.docType)
        elements.docType.selectedIndex   = +(getLS(LS_KEYS.docTypeKey).value ?? '0')
    if (elements.useAI)
        elements.useAI.checked           = getLS(LS_KEYS.useAI).value ?? false
    if (elements.uploadRTFButton)
        elements.uploadRTFButton.onclick = () => elements.uploadRTF.click()
}
